import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import apiClient, { API_ENDPOINTS } from '../../config/api'
import { isSmallShopMode } from '../../utils/smallShopMode'

const AddBranch = () => {
  const smallShopMode = isSmallShopMode()
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    warehouse: ''
  })
  const [warehouses, setWarehouses] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingWarehouses, setLoadingWarehouses] = useState(false)

  useEffect(() => {
    if (!smallShopMode) {
      fetchWarehouses()
    }
  }, [smallShopMode])

  const fetchWarehouses = async () => {
    setLoadingWarehouses(true)
    try {
      const response = await apiClient.get(API_ENDPOINTS.WAREHOUSES)
      setWarehouses(response.data.results || response.data || [])
    } catch (error) {
      console.error('Error fetching warehouses:', error)
      setWarehouses([])
    } finally {
      setLoadingWarehouses(false)
    }
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      if (!smallShopMode && !formData.warehouse) {
        Swal.fire({
          icon: 'error',
          title: 'Validation Error',
          text: 'Warehouse is required'
        })
        setLoading(false)
        return
      }

      const payload = {
        name: formData.name,
        address: formData.address || '',
      }
      if (!smallShopMode && formData.warehouse) {
        payload.warehouse = parseInt(formData.warehouse, 10)
      }

      await apiClient.post(API_ENDPOINTS.BRANCHES, payload)

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Branch created successfully!',
        confirmButtonText: 'OK'
      })

      // Reset form
      setFormData({
        name: '',
        address: '',
        warehouse: ''
      })
    } catch (error) {
      console.error('Error creating branch:', error)
      const errorMessage = error.response?.data?.name?.[0] || 
                          error.response?.data?.warehouse?.[0] ||
                          error.response?.data?.non_field_errors?.[0] ||
                          error.response?.data?.detail ||
                          error.response?.data?.message ||
                          'Failed to create branch. Please try again.'
      
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className="pagetitle">
        <h1>Add Branch</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item">Branches</li>
            <li className="breadcrumb-item active">Add Branch</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-shop me-2"></i>
                  Create New Branch
                </h5>

                <form onSubmit={handleSubmit}>
                  {!smallShopMode && (
                    <div className="row mb-3">
                      <label htmlFor="warehouse" className="col-sm-2 col-form-label">Warehouse <span className="text-danger">*</span></label>
                      <div className="col-sm-10">
                        <select
                          className="form-select"
                          id="warehouse"
                          name="warehouse"
                          value={formData.warehouse}
                          onChange={handleChange}
                          required
                          disabled={loadingWarehouses}
                        >
                          <option value="">{loadingWarehouses ? 'Loading warehouses...' : 'Select Warehouse'}</option>
                          {warehouses.map(warehouse => (
                            <option key={warehouse.id} value={warehouse.id}>
                              {warehouse.name || `Warehouse ${warehouse.id}`}
                            </option>
                          ))}
                        </select>
                        {warehouses.length === 0 && !loadingWarehouses && (
                          <small className="text-muted">No warehouses available. Please add warehouses first.</small>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="row mb-3">
                    <label htmlFor="name" className="col-sm-2 col-form-label">Branch Name <span className="text-danger">*</span></label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Enter branch name"
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label htmlFor="address" className="col-sm-2 col-form-label">Address</label>
                    <div className="col-sm-10">
                      <textarea
                        className="form-control"
                        id="address"
                        name="address"
                        rows="3"
                        value={formData.address}
                        onChange={handleChange}
                        placeholder="Enter branch address"
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-sm-10 offset-sm-2">
                      <button 
                        type="submit" 
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Creating...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-plus-circle me-2"></i>
                            Create Branch
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AddBranch

